import { pendingStipendsBadgeState } from "@common/state/badgeNumberState";
import { roleState } from "@common/state/roleState";
import { StipendExpenseStatus, UserRole } from "@common/utils/graphql";
import { useMemo } from "react";
import { useRecoilValue } from "recoil";

export enum AdminStipendsSelectedTab {
  Pending = "Pending",
  History = "History",
  StipendManager = "Stipend Manager",
}

export const useAdminStipendsTabs = (
  selectedTab: AdminStipendsSelectedTab,
  setPage: (idx: number) => void,
) => {
  const role = useRecoilValue(roleState);
  const pendingBadgeNumber = useRecoilValue(pendingStipendsBadgeState);

  const tabs = useMemo(() => {
    const tabs = [
      {
        id: AdminStipendsSelectedTab.Pending,
        name: AdminStipendsSelectedTab.Pending.toString(),
        route: `/${role}/stipends/pending`,
        badgeNumber: pendingBadgeNumber,
      },
      {
        id: AdminStipendsSelectedTab.History,
        name: AdminStipendsSelectedTab.History.toString(),
        route: `/${role}/stipends/history`,
      },
    ];
    // NOTE: This is because useAdminStipendsTabs is also used by managers
    if (role === UserRole.Admin) {
      tabs.push({
        id: AdminStipendsSelectedTab.StipendManager,
        name: AdminStipendsSelectedTab.StipendManager,
        route: `/${role}/stipends/stipend-manager`,
      });
    }
    return tabs;
  }, [role, pendingBadgeNumber]);

  const status = useMemo(() => {
    setPage(0);

    switch (selectedTab) {
      case AdminStipendsSelectedTab.Pending:
        return [StipendExpenseStatus.Pending];
      case AdminStipendsSelectedTab.History:
        return [StipendExpenseStatus.Approved, StipendExpenseStatus.Rejected];
      case AdminStipendsSelectedTab.StipendManager:
        return [];
    }
  }, [selectedTab, setPage]);

  return {
    status,
    tabs,
  };
};
